import {lazy} from 'react';

export const RteLinkLazy = lazy(() => import(/* webpackChunkName: "rteLink" */ '.'));
